import { useLazyDeleteTemplateQuery } from "@/modules/template/services";
import { useNotify } from "@/shared/hooks";
import { Modal } from "@ab.uitools/ui-library/components/Modal";
import { Text } from "@ab.uitools/ui-library/components/Text";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  id?: string | null;
  setId: Dispatch<SetStateAction<string | null>>;
  refetch: () => void;
  isDeleteModalOpen: boolean;
  templateName: string;
  setIsDeleteModalOpen: Dispatch<SetStateAction<boolean>>;
}


export const DeleteTemplateModal = ({
  id,
  setId,
  refetch,
  templateName,
  isDeleteModalOpen,
  setIsDeleteModalOpen,
}: Props) => {
  const { t } = useTranslation();
  const { showErrorSnackbar, showSuccessSnackbar } = useNotify();
  const [deleteTemplate, { isLoading: isDeleteTemplateLoading }] = useLazyDeleteTemplateQuery();

  const handleDeleteTemplate = () => {
    if (id) {
      deleteTemplate({ id })
        .unwrap()
        .then(() => {
          setIsDeleteModalOpen(false);
          refetch();
          showSuccessSnackbar(t("alerts.templateHasBeenSuccessfullyDeleted"));
        })
        .catch((err) => {
          showErrorSnackbar(err);
          setIsDeleteModalOpen(false);
        })
        .finally(() => {
          setId(null);
        });
    }
  };

  return (
    <Modal
      isOpen={isDeleteModalOpen}
      onClose={() => setIsDeleteModalOpen(false)}
      onSubmit={handleDeleteTemplate}
      buttonProps={{
        confirm: {
          buttonText: t("general.delete"),
          type: "danger",
          isLoading: isDeleteTemplateLoading,
          disabled: isDeleteTemplateLoading,
        },
        cancel: { buttonText: t("general.cancel") },
      }}
      titleProps={{
        title: t("template.deleteModal.title"),
        size: "large"
      }}
    >
      <div>
        <Text>{t("template.deleteModal.description", { name: templateName })}</Text>
      </div>
    </Modal>
  );
};
